import React from 'react';
import { Select, Spin } from 'antd';
import { useVesselJourneys } from '@/api/Vessel';
import { useTranslate } from '@/translations';

type VesselJourneyFieldProps = {
  vesselId?: number;
  value?: number;
  disabled?: boolean;
  onChange?: (journeyId?: number) => void;
};

export const VesselJourneyField = ({
  vesselId,
  value,
  disabled,
  onChange,
}: VesselJourneyFieldProps) => {
  const { t } = useTranslate();
  const journeys = useVesselJourneys(vesselId, Boolean(vesselId));
  const loading =
    Boolean(vesselId) && (journeys.isPending || journeys.isFetching);
  const options = (journeys.data ?? []).map((journey) => {
    const route = [
      journey.originPortName ?? 'Unknown Origin',
      journey.destinationPortName ?? 'Unknown Destination',
    ].join(' → ');
    const label =
      [journey.voyage, route].filter(Boolean).join(' · ') || `#${journey.id}`;
    return { value: journey.id, label };
  });

  return (
    <Select
      allowClear
      showSearch
      optionFilterProp="label"
      disabled={disabled || !vesselId}
      loading={loading}
      notFoundContent={loading ? <Spin size="small" /> : undefined}
      value={value}
      options={options}
      placeholder={t('vesselJourney')}
      onChange={(next) => onChange?.(next)}
    />
  );
};
